function n(t) {
  return t.composedPath()[0];
}
export {
  n as getEventTarget
};
